// extracted by mini-css-extract-plugin
module.exports = {"scopeCell":"style-module_scopeCell__3mh2juzTKBLGPWcrGQZrYx","defineScope":"style-module_defineScope__21Uz812vp9Kr_ylVDCqKgn"};